"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _reactI18next = require("react-i18next");
var _elementHeadline = _interopRequireDefault(require("../element-headline"));
var _svgicon = _interopRequireDefault(require("../../helper/svgicon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  item: {
    marginBottom: theme.spacing(1),
    "& a": {
      alignItems: "center",
      background: theme.palette.background.light,
      color: theme.palette.foreground.contact.label,
      display: "flex",
      padding: theme.spacing(1.5, 2),
      transitionProperty: "all",
      transitionDuration: theme.transitions.duration.standard,
      transitionTimingFunction: theme.transitions.easing.sharp,
      "&:hover": {
        background: theme.palette.primary.main,
        color: theme.palette.common.white,
        "& $icon": {
          background: theme.palette.common.white,
          color: theme.palette.primary.main
        }
      }
    }
  },
  icon: {
    alignItems: "center",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "50%",
    color: theme.palette.common.white,
    cursor: "pointer",
    display: "flex",
    height: theme.spacing(3.5),
    justifyContent: "center",
    marginRight: theme.spacing(1),
    transitionProperty: "all",
    transitionDuration: theme.transitions.duration.standard,
    transitionTimingFunction: theme.transitions.easing.sharp,
    width: theme.spacing(3.5)
  }
}));
const ContactSection = _ref => {
  let {
    email,
    phone
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_elementHeadline.default, {
    title: t("site.ui.headlines.contact"),
    component: "h1"
  }), /*#__PURE__*/_react.default.createElement(_core.Box, {
    my: 2
  }, phone && /*#__PURE__*/_react.default.createElement("div", {
    className: css.item
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "tel:".concat(phone)
  }, /*#__PURE__*/_react.default.createElement(_svgicon.default, {
    className: css.icon,
    src: "/img/icons/phone.svg",
    size: 16
  }), phone)), email && /*#__PURE__*/_react.default.createElement("div", {
    className: css.item
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "mailto:".concat(email)
  }, /*#__PURE__*/_react.default.createElement(_svgicon.default, {
    className: css.icon,
    src: "/img/icons/mail.svg",
    size: 16
  }), email))));
};
var _default = exports.default = ContactSection;